// src/pages/Dictionary/DictionaryInputCN.jsx
import { useMemo } from "react";
import { DICTIONARY_GROUPS_CN, VERSION_META_CN } from "../../../lib/dictionaryApi";

export default function DictionaryInputCN({
  selected,             // { [groupKey]: Set([...]) }
  onToggle,             // (groupKey, item) => void
  version,              // "1" | "2" | "3"
  onChangeVersion,      // (next) => void
  onSubmit,             // () => void
  loading,              // boolean
}) {
  // 한국어 전용 데이터
  const groups = useMemo(() => DICTIONARY_GROUPS_CN(), []);
  const versions = useMemo(() => VERSION_META_CN(), []);

  return (
    <div className="dictionaryinput">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit?.();
        }}
      >
        {/* 증상 그룹 6개 — map 기반 */}
        {groups.map((g) => (
          <div className="form_section" key={g.key}>
            <h3 className="sectionTitle">{g.title}</h3>
            <div className="buttonbox">
              {g.items.map((item) => {
                const isActive = !!selected[g.key]?.has(item);
                return (
                  <button
                    type="button"
                    key={item}
                    className={`symptom ${isActive ? "active" : ""}`}
                    onClick={() => onToggle(g.key, item)}
                  >
                    {item}
                  </button>
                );
              })}
            </div>
          </div>
        ))}

        {/* 버전 선택 (기본/상세/전문가) */}
        <div className="submit_type">
          <div className="version-selector">
            {versions.map((v) => (
              <button
                key={v.value}
                type="button"
                className={`version-btn ${version === v.value ? "active" : ""}`}
                onClick={() => onChangeVersion(v.value)}
              >
                {v.label}
              </button>
            ))}
          </div>
        </div>

        {/* 제출 */}
        <div className="submit_button">
          <button type="submit" className="btn" disabled={loading}>
            {loading ? "分析中..." : "查看AI分析结果"}
          </button>
        </div>
      </form>
    </div>
  );
}
